<template>
    <div class="account">
        <el-breadcrumb separator-class="el-icon-arrow-right" v-if="postList.headerTitle">
            <el-breadcrumb-item>合作方</el-breadcrumb-item>
        </el-breadcrumb>
        <el-row class="main_header">
            <div class="main_header_item" v-if="postList.code">
                <el-input v-model="code" placeholder="请输入代码" clearable @keyup.enter.native="getList(0, 1)"></el-input>
            </div>
            <div class="main_header_item" v-if="postList.name">
                <el-input v-model="name" placeholder="请输入名称" clearable @keyup.enter.native="getList(0, 1)"></el-input>
            </div>
            <div class="main_header_item" v-if="postList.sf_code">
                <el-input v-model="sf_code" placeholder="请输入SF_CODE" clearable @keyup.enter.native="getList(0, 1)"></el-input>
            </div>
            <div class="main_header_item" v-if="postList.province_rid">
                <el-select filterable v-model="province_rid" placeholder="请选择省份" clearable @change="provinceChange">
                    <el-option v-for="item in provincesOptions" :key="item.value" :label="item.label" :value="item.value"> </el-option>
                </el-select>
            </div>
            <div class="main_header_item" v-if="postList.city_rid">
                <el-select v-model="city_name" placeholder="请选择城市" clearable filterable value-key="value" @change="cityChange">
                    <el-option v-for="item in cityOptions" :key="item.value" :label="item.label" :value="item"> </el-option>
                </el-select>
            </div>
            <div class="main_header_item" v-if="postList.business_unit_rid">
                <vDropdown
                    model_key="business_unit_rid"
                    model_name="请选择业务单元"
                    :model_value_default="business_unit_rid"
                    request_uri="dropdownBusinessUnits"
                    select_value="rid"
                    @onDropChange="onDropChange"
                    ref="business_unit_rid_ref"
                ></vDropdown>
            </div>
            <div class="main_header_item">
                <el-select v-model="person_rid" placeholder="请选择人员" clearable filterable>
                    <el-option v-for="item in personOptions" :key="item.rid" :label="item.name" :value="item.rid"> </el-option>
                </el-select>
            </div>
        </el-row>
        <div class="main_list">
            <div class="flex">
                <el-button size="small" plain @click="addAcount" icon="el-icon-plus" v-if="postList.addBtn">新增合作方</el-button>
                <!-- <el-button size="mini" @click="updateDate" :loading="btnLoading" v-if="postList.updateBtn">刷新规划日</el-button> -->
                <!-- <el-button size="mini" @click="updateBusinessUnit" :loading="btnLoading">刷新业务单元</el-button> -->
                <div class="main_header_btns">
                    <el-button type="primary" size="small" @click="getList(0, 1)" v-if="postList.searchBtn">搜索</el-button>
                    <el-button size="small" type="primary" plain @click="reset" v-if="postList.resetBtn">重置</el-button>
                    <el-button
                        size="small"
                        plain
                        icon="el-icon-bottom"
                        @click="getList(1)"
                        :loading="down_loading"
                        v-if="postList.downFileBtn"
                        >下载</el-button
                    >
                    <crm-upload obj="partner"></crm-upload>
                    <!-- 设置子组件 调整列显示隐藏 顺序 -->
                    <draggableList :draggable="draggable" @isErrShow="isErrshow" v-if="postList.setBtn"></draggableList>
                </div>
            </div>
            <el-table
                :data="tableData"
                border
                ref="tableDataRef"
                @sort-change="changeSort"
                :max-height="this.$tableHeight"
                @header-dragend="changeColWidth"
                class="partner"
                v-loading="loading"
                element-loading-text="拼命加载中"
                element-loading-spinner="el-icon-loading"
                element-loading-background="rgba(255, 255, 255, 0.8)"
                style="width: 100%"
            >
                <template v-for="(item, index) in colData">
                    <el-table-column
                        :key="index"
                        :prop="item.prop"
                        :label="item.title"
                        :min-width="item.width"
                        :sortable="item.sort"
                        align="left"
                        show-overflow-tooltip
                        v-if="colData[index].is_show"
                    >
                        <template slot-scope="scope" style="height: 100%">
                            <div
                                v-if="
                                    item.prop == 'code' ||
                                    item.prop == 'name' ||
                                    item.prop == 'main_contact_name' ||
                                    item.prop == 'dedicated_account_name'
                                "
                            >
                                <el-link
                                    v-if="scope.row[item.prop]"
                                    type="primary"
                                    @click="handleClick(scope.row, item.prop)"
                                    style="font-size: 11px"
                                    >{{ scope.row[item.prop] }}
                                </el-link>
                            </div>
                            <div v-else-if="item.prop == 'parent_name'">
                                <span v-if="parent_show">
                                    {{ scope.row[item.prop] }}
                                </span>
                                <el-link v-else type="primary" @click="handleClick(scope.row, item.prop)" style="font-size: 11px"
                                    >{{ scope.row[item.prop] }}
                                </el-link>
                            </div>
                            <div v-else>
                                <span> {{ scope.row[item.prop] }} </span>
                            </div>
                        </template>
                    </el-table-column>
                </template>
                <el-table-column label="操作" width="80" fixed="right">
                    <template slot-scope="scope">
                        <el-tooltip class="item" effect="dark" content="复制" placement="top-start">
                            <i class="el-icon-menu" @click="copy(scope.row.rid)"></i>
                        </el-tooltip>
                        <el-tooltip class="item" effect="dark" content="编辑" placement="top-start">
                            <i class="el-icon-s-claim" @click="editDetails(scope.row.rid)"></i>
                        </el-tooltip>
                        <el-tooltip class="item" effect="dark" content="删除" placement="top-start">
                            <i class="el-icon-delete-solid" @click="amend(scope.row.id)"></i>
                        </el-tooltip>
                    </template>
                </el-table-column>
            </el-table>
            <div class="pagination">
                <el-pagination
                    background
                    layout="total,prev, pager, next, sizes, jumper"
                    @current-change="currentChange"
                    @size-change="sizeChange"
                    :page-sizes="[10, 25, 50, 75, 100]"
                    :current-page.sync="page"
                    :page-size="row"
                    :total="total"
                ></el-pagination>
            </div>
        </div>
    </div>
</template>
<script>
import { onReSize } from '../../../../../js/common';
import draggableList from '../../../../common/Drawer.vue';
import crmUpload from '../../../../common/Upload.vue';
export default {
    inject: ['reload'],
    //注册draggable组件
    components: {
        draggableList,
        crmUpload
    },
    name: 'partnerComponent',
    data() {
        return {
            draggable: {
                data_name: 'partner'
            },
            down_loading: false,
            btnLoading: false,
            tableData: [],
            colData: [],
            total: 0,
            page: 1,
            row: 25,
            parent_rid: '',
            sort: '', //排序参数
            data_name: '', //排序参数
            loading: true,
            code: '', //code
            name: '', // 记录ID
            sf_code: '',
            province_rid: '', // 省ID
            city_rid: '', // 市ID
            business_unit_rid: '',
            city_name: '',
            provincesOptions: [], //省份列表
            cityOptions: [], //城市列表
            parent_show: false,
            postList1: {},
            personOptions: [],
            person_rid: ''
        };
    },
    props: {
        postList: {
            type: Object
        }
    },
    created() {
        this.postList1 = this.postList;
    },
    watch: {
        postList1: {
            handler(newValue, oldValue) {
                if (newValue.params) {
                    if (newValue.params.parent_rid) {
                        this.parent_rid = newValue.params.parent_rid;
                        this.parent_name = newValue.params.parent_name;
                        this.parent_show = true;
                        this.getList(0);
                    } else {
                        this.parent_rid = '';
                        this.parent_name = '';
                        this.parent_show = false;
                    }
                }
            },
            deep: true
        }
    },
    beforeMount() {
        //详情内调用不用本地存储的params
        if (!this.postList.params) {
            //列表页面调用 优先取本地存储
            var paramsList = JSON.parse(localStorage.getItem('paramsList'));
            if (paramsList['partner_params']) {
                this.page = paramsList['partner_params'].page;
                this.row = paramsList['partner_params'].row;
                this.name = paramsList['partner_params'].name;
                this.sf_code = paramsList['partner_params'].sf_code;
                // this.data_name = paramsList['partner_params'].data_name;
                // this.sort = paramsList['partner_params'].sort;
                this.code = paramsList['partner_params'].code;
                this.city_rid = paramsList['partner_params'].city_rid;
                this.city_name = paramsList['partner_params'].city_name;
                this.parent_rid = paramsList['partner_params'].parent_rid;
                this.province_rid = paramsList['partner_params'].province_rid;
                this.business_unit_rid = paramsList['partner_params'].business_unit_rid;
                this.person_rid = paramsList['partner_params'].person_rid;
            }
        }
    },
    mounted() {
        this.$nextTick(() => {
            this.selectedColData(); //筛选列
            this.getAdminDropDown();
            if (this.postList.params) {
                //如果详情列表需要搜索参数 重置按钮放出来 注意 传来的id不可被重置掉
                this.row = 10;
            } else {
                this.getProvinces(); //获取省份
                this.getList(0);
            }
        });
    },
    methods: {
        //子组件更新完毕
        isErrshow(data) {
            //刷新下页面
            this.reload();
        },
        //列宽改变事件
        changeColWidth(nw, ow, col, evt) {
            onReSize('partner', this);
        },
        //筛选列
        selectedColData() {
            this.colData = JSON.parse(localStorage.getItem('dataList')).partner;
        },
        //前往编辑页面
        editDetails(id) {
            this.$router.push({
                path: 'partnerEdit',
                query: {
                    type: 1,
                    id: id
                }
            });
        },
        //复制页面
        copy(id) {
            this.$router.push({
                path: 'partnerEdit',
                query: {
                    type: 5,
                    id: id
                }
            });
        },
        //删除当前行
        amend(id) {
            var params = {
                id: id
            };
            let messages = '此操作将删除此条数据，是否继续?';
            this.$msgbox(messages, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            })
                .then(() => {
                    this.$api
                        .partnerDelete(params)
                        .then((res) => {
                            if (res.code == 0) {
                                this.$message({
                                    showClose: true,
                                    message: '删除成功',
                                    type: 'success'
                                });
                                this.getList(0);
                            }
                        })
                        .catch((error) => {});
                })
                .catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    });
                });
        },
        // 从后台获取数据,重新排序
        changeSort(val) {
            this.data_name = val.prop;
            if (val.order == 'ascending') {
                this.sort = 'asc';
            } else if (val.order == 'descending') {
                this.sort = 'desc';
            }
            if (!this.postList.params) {
                var newParamsList = JSON.parse(localStorage.getItem('paramsList'));
                if (newParamsList['partner_params']) {
                    newParamsList['partner_params'].data_name = val.prop;
                    newParamsList['partner_params'].sort = this.sort;
                    localStorage.setItem('paramsList', JSON.stringify(newParamsList));
                }
            }
            if (this.sort !== '') {
                this.getList(0); //获取列表
            }
        },
        //获取省份
        getProvinces() {
            let params = {
                has_all: '0'
            };
            this.$api
                .provinces(params)
                .then((res) => {
                    if (res.code == 0) {
                        this.provincesOptions = [];
                        let data = res.data;
                        data.forEach((value, index) => {
                            this.provincesOptions.push({
                                value: value.rid,
                                label: value.name
                            });
                        });
                    }
                })
                .catch((error) => {});
        },
        //省份改变请求当下省份下的城市
        provinceChange() {
            this.cityOptions = [];
            this.city_rid = '';
            this.city_name = '';
            if (this.province_rid) {
                let params = {
                    parent_rid: this.province_rid
                };
                this.$api
                    .cities(params)
                    .then((res) => {
                        if (res.code == 0) {
                            this.cityOptions = [];
                            let data = res.data;
                            data.forEach((value, index) => {
                                this.cityOptions.push({
                                    value: value.rid,
                                    label: value.name
                                });
                            });
                        }
                    })
                    .catch((error) => {});
            }
        },
        //新增
        addAcount() {
            if (this.postList.params) {
                if (this.postList.params.parent_rid) {
                    this.$router.push({
                        path: '/partnerEdit',
                        query: {
                            type: 4,
                            id: this.rid,
                            parent_name: this.postList.params.parent_name,
                            parent_rid: this.postList.params.parent_rid
                        }
                    });
                }
            } else {
                this.$router.push({
                    path: '/partnerEdit',
                    query: {
                        type: 3
                    }
                });
            }
        }, //刷新规划日
        updateDate() {
            this.btnLoading = true;
            let params = {};
            this.$api
                .flushSchemeDate(params)
                .then((res) => {
                    if (res.code == 0) {
                        this.btnLoading = false;
                        this.$message({
                            message: '刷新成功!',
                            type: 'success'
                        });
                        this.getList(0); //获取列表
                    } else {
                        this.btnLoading = false;
                    }
                })
                .catch((error) => {
                    this.btnLoading = false;
                });
        },
        updateBusinessUnit() {
            this.btnLoading = true;
            let params = {};
            this.$api
                .flushBusinessUnitFromSf(params)
                .then((res) => {
                    if (res.code == 0) {
                        this.btnLoading = false;
                        this.$message({
                            message: '刷新成功!',
                            type: 'success'
                        });
                        this.getList(0); //获取列表
                    } else {
                        this.btnLoading = false;
                    }
                })
                .catch((error) => {
                    this.btnLoading = false;
                });
        },

        //跳转详情
        handleClick(row, prop) {
            if (prop == 'code' || prop == 'name') {
                if (this.postList.params) {
                    if (this.postList.params.parent_rid) {
                        this.parent_rid = row.rid;
                    }
                }
                this.$router.push({
                    path: '/partnerDetails',
                    query: {
                        id: row.rid
                    }
                });
            } else if (prop == 'parent_name') {
                if (this.postList.params) {
                    if (this.postList.params.parent_rid) {
                        this.parent_rid = row.parent_rid;
                    }
                }
                this.$router.push({
                    path: '/partnerDetails',
                    query: {
                        id: row.parent_rid
                    }
                });
            } else if (prop == 'main_contact_name') {
                this.$router.push({
                    path: '/contactDetail',
                    query: {
                        id: row.main_contact_rid
                    }
                });
            } else if (prop == 'dedicated_account_name') {
                this.$router.push({
                    path: '/accountDetails',
                    query: {
                        id: row.dedicated_account_rid
                    }
                });
            }
        },
        cityChange(value) {
            if (value) {
                this.city_name = value.label;
                this.city_rid = value.value;
            } else {
                this.city_name = '';
                this.city_rid = '';
            }
        },
        //获取人员下拉
        getAdminDropDown() {
            let params = {};
            this.$api
                .dropdownPerson(params)
                .then((res) => {
                    if (res.code == 0) {
                        this.personOptions = res.data;
                    }
                })
                .catch((error) => {});
        },
        //获取列表数据
        getList(type_data, type) {
            if (type == 1) {
                this.page = 1;
            }
            var params = {
                page: this.page,
                row: this.row,
                name: this.name,
                sf_code: this.sf_code,
                code: this.code,
                city_rid: this.city_rid,
                city_name: this.city_name,
                parent_rid: this.parent_rid,
                sort: [this.data_name, this.sort],
                province_rid: this.province_rid,
                business_unit_rid: this.business_unit_rid,
                person_rid: this.person_rid,
                is_export: type_data
            };
            //当点击 或者触发回车事件保存参数
            if (type == 1) {
                var newParamsList = JSON.parse(localStorage.getItem('paramsList'));
                newParamsList['partner_params'] = params;
                localStorage.setItem('paramsList', JSON.stringify(newParamsList));
            }
            if (type_data == 0) {
                this.loading = true;
                this.$api
                    .partnerLists(params)
                    .then((res) => {
                        this.loading = false;
                        if (res.code == 0) {
                            this.tableData = res.data.data;
                            this.total = res.data.total;
                            //判断当前搜素页面参数是否大于最后一页 大于的话取最后一页的参数存起来并用最后一页的参数请求
                            if (res.data.current_page > res.data.last_page) {
                                var newParamsList = JSON.parse(localStorage.getItem('paramsList'));
                                newParamsList['partner_params'].page = res.data.last_page;
                                localStorage.setItem('paramsList', JSON.stringify(newParamsList));
                                this.page = res.data.last_page;
                            }
                        }
                    })
                    .catch((error) => {
                        this.loading = false;
                    });
            } else {
                this.down_loading = true;
                params.page = 1;
                this.$api
                    .partnerListsDownFile(params)
                    .then((res) => {
                        this.$message({
                            message: '下载成功!',
                            type: 'success'
                        });
                        this.down_loading = false;
                    })
                    .catch((error) => {
                        this.down_loading = false;
                    });
            }
        },
        // 点击分页当前页数
        currentChange(val) {
            this.page = val;
            //当分页发生改变的时候存到本地更改本地存储好的参数
            if (!this.postList.params) {
                var newParamsList = JSON.parse(localStorage.getItem('paramsList'));
                if (newParamsList['partner_params']) {
                    newParamsList['partner_params'].page = val;
                    localStorage.setItem('paramsList', JSON.stringify(newParamsList));
                } else {
                    var params = {
                        page: this.page,
                        row: this.row,
                        name: this.name,
                        sf_code: this.sf_code,
                        code: this.code,
                        city_rid: this.city_rid,
                        city_name: this.city_name,
                        parent_rid: this.parent_rid,
                        sort: [this.data_name, this.sort],
                        province_rid: this.province_rid,
                        business_unit_rid: this.business_unit_rid,
                        person_rid: this.person_rid
                    };
                    var newParamsList = JSON.parse(localStorage.getItem('paramsList'));
                    newParamsList['partner_params'] = params;
                    localStorage.setItem('paramsList', JSON.stringify(newParamsList));
                }
            }
            this.getList(0);
        },
        // 切换每页条数
        sizeChange(val) {
            this.row = val;
            //当页数发生改变的时候存到本地更改本地存储好的参数
            if (!this.postList.params) {
                var newParamsList = JSON.parse(localStorage.getItem('paramsList'));
                if (newParamsList['partner_params']) {
                    newParamsList['partner_params'].row = val;
                    localStorage.setItem('paramsList', JSON.stringify(newParamsList));
                } else {
                    var params = {
                        page: this.page,
                        row: this.row,
                        name: this.name,
                        sf_code: this.sf_code,
                        code: this.code,
                        city_rid: this.city_rid,
                        city_name: this.city_name,
                        parent_rid: this.parent_rid,
                        sort: [this.data_name, this.sort],
                        province_rid: this.province_rid,
                        business_unit_rid: this.business_unit_rid
                    };
                    var newParamsList = JSON.parse(localStorage.getItem('paramsList'));
                    newParamsList['partner_params'] = params;
                    localStorage.setItem('paramsList', JSON.stringify(newParamsList));
                }
            }
            this.getList(0);
        },
        onDropChange(key, value) {
            this[key] = value;
        },
        //重置页面数据
        reset() {
            this.code = '';
            this.name = '';
            this.sf_code = '';
            this.province_rid = '';
            this.business_unit_rid = '';
            this.city_rid = '';
            this.city_name = '';
            this.sort = '';
            this.data_name = '';
            this.page = 1;
            this.row = 25;
            this.person_rid = '';
            var params = {
                page: 1,
                row: 25,
                sort: ['', ''],
                code: '',
                name: '',
                sf_code: '',
                province_rid: '',
                city_rid: '',
                city_name: '',
                person_rid: ''
            };
            var newParamsList = JSON.parse(localStorage.getItem('paramsList'));
            newParamsList['partner_params'] = params;
            localStorage.setItem('paramsList', JSON.stringify(newParamsList));
            this.getList(0);
        }
    }
};
</script>
<style lang="scss" scoped>
/deep/ .el-table__empty-block {
    width: 100% !important;
    min-width: 100% !important;
    max-width: 100% !important;
    padding-right: 100% !important;
}
</style>